// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__24Jdr","hideOnTablet":"styles_hideOnTablet__YkXtf","hideOnMobile":"styles_hideOnMobile__1CbCG","card":"styles_card__2e-mm"};